module.exports = __webpack_public_path__ + "static/media/presentation_yow_2017.f2e05914.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/aboutme/presentation_yow_2017.jpg
// module id = 142
// module chunks = 0